import React, { useState } from "react";
import TextField from "../components/Textfield/TextField";
import "./views.css";
import Button from "../components/Button/Button";
import { GETCHARGE } from "../services/services";

const ChargeWithCode = () => {
  const [phone, setPhone] = useState();
  const [mount, setMount] = useState();
  const [toast, setToast] = useState("");
  return (
    <div className={"ChargeWithCode"}>
      {/* <br/>
            <br/>
            <TextField id={'phone'} type={'tel'} onChange={(e) => setPhone(e.target.value)}  label={'موبایل'} value={phone} />
            <TextField id={'code'} type={'tel'} onChange={(e) => setMount(e.target.value)}  label={'میزان شارژ به ریال'} value={mount} />
            <br/>
            <div className="">
                <Button onClick={() => {
                    const body = {
                        "PhoneNumber": phone,
                        "ChargeAmount": Number(mount)
                    }
                    if (phone?.length === 11){
                        GETCHARGE(body).then(res => {
                            if (res.data.errorCode === 200) {
                                setToast('با موفقیت شارژ شد')
                                setTimeout(()=>{
                                    setToast('')
                                }, 2500)
                            } else {
                                setToast(res?.data?.message)
                                setTimeout(()=>{
                                    setToast('')
                                }, 2500)
                            }
                        })
                    }
                }} className="third-button">
                   ارسال
                </Button>
            </div>
            <br/>
            <br/>
            <p>{toast}</p> */}
    </div>
  );
};

export default ChargeWithCode;
